import { Colors } from "@/enums/Colors";
import { LazoPaths } from "@/enums/LazoPaths";
import { Box, Button, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Computer from "../../../assets/images/NotSupportedImg.svg";
import QuickbooksLogo from "../../../assets/images/quickbooks_logo.png";

const ConnectButton = styled(Button)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: Colors.WHITE,
  color: Colors.BLACK_151517,
  borderRadius: ".5rem",
  textTransform: "none",
  fontSize: ".875rem",
  lineHeight: "1.25rem",
  fontWeight: "600",
  gap: "0.5rem",
  "&.MuiButtonBase-root": {
    padding: ".75rem 1rem",
  },
  ":hover": {
    backgroundColor: Colors.WHITE,
  },
});

const ImgContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "50%",
  padding: ".5rem",
});

export default function ConnectAccounting() {
  const navigate = useNavigate();
  const { t } = useTranslation("integrations");

  function handleConnectButtonClick() {
    navigate(LazoPaths.INTEGRATIONS);
  }

  return (
    <>
      <ImgContainer>
        <img src={Computer.src} height={"100%"} />
      </ImgContainer>
      <Typography
        sx={{
          marginX: "3rem",
          textAlign: "center",
          fontWeight: "500",
          fontSize: "1.5rem",
          lineHeight: "1.75rem",
          color: Colors.WHITE,
        }}
      >
        {t("connectAccounting.description")}
      </Typography>
      <ConnectButton onClick={handleConnectButtonClick}>
        {t("connectAccounting.connectButton")} <img src={QuickbooksLogo.src} />
      </ConnectButton>
    </>
  );
}
